import { useLiveQuery } from 'dexie-react-hooks'
import { lireEntreprise } from '../lib/entreprise'
import { getBase } from '../outbox/base'

/** L'entreprise est-elle en franchise en base de TVA (réglages entreprise) ? Faux tant que la lecture n'est pas faite. */
export function useFranchiseTva(): boolean {
  const base = getBase()
  return useLiveQuery(async () => (await lireEntreprise(base))?.franchiseTva ?? false, [], false)
}
